// Aba Jogar (canvas F02 e 1.1): CRIAR SALA e Entrar com código no alto, a linha do dia (ofensiva e missões) e, no
// centro, a lista de salas abertas (a mesma de telas/Salas.tsx), com as abas Abertas e Valendo Tentos. No celular
// deitado e no computador, os botões, a linha do dia, as abas e os filtros ficam à esquerda e a lista à direita.
// A divisão fica no perfil e no fim de partida; o marcador, os trios fixos, Planos, Indique e ganhe e Como jogar
// ficam no Perfil. Com a Liga da Semana oculta (LIGA_DA_SEMANA), o Jogar não tem JOGAR NA LIGA; com ela no ar, o bloco
// da liga (faixa, divisão, ofensiva, missões e JOGAR NA LIGA) volta, logo abaixo dos botões.
import { useEffect, useState } from 'react';
import type { SalaNaLista } from '@truco6/mesa/protocolo';
import type { OfensivaNaTela, PainelMissoes, PainelTrios } from '@truco6/gamificacao';
import { type PainelLiga, lerLiga, lerTrios } from '../comum/api.ts';
import { ligaNoAr } from '../comum/liga.ts';
import { comRanking, conta, type PerfilConta, type Sessao } from '../comum/conta.ts';
import { avisarNaTela } from '../comum/aviso.tsx';
import { CartaoAvisoRanking } from '../comum/RankingDaCidade.tsx';
import { medir } from '../comum/medicao.ts';
import { ir } from '../comum/rotas.ts';
import { Rosto } from '../comum/Rosto.tsx';
import { CartaoPush } from '../comum/AvisosNoCelular.tsx';
import { usePresenca } from '../comum/presenca.ts';
import { useAgora } from '../comum/useMesa.ts';
import { OfensivaNoInicio, QuenteNoInicio, emDias } from '../liga/ofensiva.tsx';
import { BarraDivisao, FaixaLiga, tempoAte } from '../liga/comum.tsx';
import { SeloNoTopo, useSemPartidas } from '../comum/SeloGratis.tsx';
import { GuiaDoDia } from '../comum/GuiaDoDia.tsx';
import { irParaMesa } from '../comum/limite.ts';
import { MissoesNoInicio } from '../liga/missoes.tsx';
import { Escudo } from '../liga/trios.tsx';
import { Icone } from './planos-comum.tsx';
import { type AbaDeSalas, SalasAbertas } from './Salas.tsx';
import { Marca } from '@truco6/ui/Marca';
import { CampoCodigo, Tela } from './comum.tsx';

// salas: a lista antes da primeira resposta da mesa (testes e vitrine).
export function Inicio({ sessao, perfil, aoMudarPerfil, aba: abaInicial = 'abertas', salas }: {
  sessao: Sessao; perfil: PerfilConta; aoMudarPerfil?: (p: PerfilConta) => void; aba?: AbaDeSalas; salas?: SalaNaLista[];
}) {
  const [erro, setErro] = useState<string | null>(null);
  const [painel, setPainel] = useState<PainelLiga | null>(null);
  const [aba, setAba] = useState<AbaDeSalas>(abaInicial);
  const [codigo, setCodigo] = useState(false); // a folha "Entrar com código"
  const agora = useAgora(30_000);
  useEffect(() => { setAba(abaInicial); }, [abaInicial]);
  useEffect(() => {
    let vivo = true;
    void lerLiga(sessao).then((p) => { if (vivo) setPainel(p); }, () => {});
    return () => { vivo = false; };
  }, [sessao.id]);
  // A aba fica no endereço (/salas?aba=tentos), sem sair do Jogar.
  const mudarAba = (a: AbaDeSalas) => { setAba(a); ir(a === 'tentos' ? { tela: 'inicio', aba: 'tentos' } : { tela: 'inicio' }, true); };
  // Sem partidas grátis hoje, CRIAR SALA e Entrar com código levam à tela Limite (a lista continua, com Assistir).
  const sem = useSemPartidas();
  const criar = () => ir(sem ? { tela: 'limite' } : { tela: 'nova-sala', ingresso: null });

  const lado = (
    <>
      <SeloNoTopo indique="longa" />
      <div className="botoes-jogar">
        <button className="btn1 criar-sala" onClick={criar}>CRIAR SALA</button>
        <button className="btn2 entrar-codigo" onClick={() => (sem ? ir({ tela: 'limite' }) : setCodigo(true))}>Entrar com código</button>
      </div>
      {erro && <p className="erro" role="alert">{erro}</p>}
      {ligaNoAr()
        ? painel && <BlocoDaLiga sessao={sessao} painel={painel} agora={agora} />
        : painel && <LinhaDoDia ofensiva={painel.ofensiva} missoes={painel.missoes} />}
      {!ligaNoAr() && painel?.quente && <QuenteNoInicio q={painel.quente} agora={agora} />}
    </>
  );
  // Os avisos que aparecem de vez em quando (cidade no ranking e notificações no celular) ficam embaixo da lista.
  const avisos = (
    <>
      {perfil.rankingRegionalAviso && (
        <CartaoAvisoRanking codigo={perfil.cidadeIbge} aoResponder={(desligar) => {
          aoMudarPerfil?.(desligar ? comRanking(perfil, false) : { ...perfil, rankingRegionalAviso: false });
          conta.rankingRegional(sessao, desligar ? false : null).then(
            () => { if (desligar) avisarNaTela('Pronto. Você aparece só no ranking do Brasil.'); },
            () => avisarNaTela('Não deu certo. Tente de novo no Perfil.'));
        }} />
      )}
      <CartaoPush sessao={sessao} />
    </>
  );
  return (
    <Tela painel>
      <div className="linha-topo topo-inicio">
        <Marca altura={32} />
        <div className="topo-direita">
          <Sino />
          <button className="eu" onClick={() => ir({ tela: 'perfil' })} aria-label="Seu perfil">
            <Rosto perfil={perfil} usuario={sessao.id} cor="var(--nos-400)" tamanho={36} />
            <span>{perfil.apelido}</span>
          </button>
        </div>
      </div>
      <h1 className="so-leitor">Jogar</h1>
      <SalasAbertas sessao={sessao} perfil={perfil} aba={aba} aoMudarAba={mudarAba} lado={lado} rodape={avisos} inicial={salas}
        vazio={(
          <div className="cartao vazio-lista vazio-jogar">
            <p>Nenhuma sala aberta agora. Crie a sua e chame a turma.</p>
            <button className="btn1 largo" onClick={criar}>CRIAR SALA</button>
          </div>
        )} />
      {codigo && <FolhaDoCodigo aoFechar={() => setCodigo(false)} />}
      {/* Guia do dia (item 67): a folha das partidas grátis na primeira abertura do dia, só no Grátis. */}
      <GuiaDoDia conta={sessao.id} />
    </Tela>
  );
}

// A Liga da Semana no ar (LIGA_DA_SEMANA): a faixa, a divisão, a ofensiva, a Rodada quente, as missões, os pontos da
// semana, o trio com quem jogar e o JOGAR NA LIGA.
function BlocoDaLiga({ sessao, painel, agora }: { sessao: Sessao; painel: PainelLiga; agora: number }) {
  const [trios, setTrios] = useState<PainelTrios | null>(null);
  const [com, setCom] = useState<string | null>(null); // jogar a liga sozinho ou com um trio fixo
  useEffect(() => {
    let vivo = true;
    void lerTrios(sessao).then((t) => { if (vivo) setTrios(t); }, () => {});
    return () => { vivo = false; };
  }, [sessao.id]);
  const prontos = trios?.trios.filter((t) => t.ativo && t.membros.length === 3) ?? [];
  return (
    <section className="cartao liga-inicio" aria-label="Liga da Semana">
      <FaixaLiga liga={painel.liga} chip={tempoAte(painel.liga.fim, agora)} />
      <BarraDivisao d={painel.divisao} />
      {painel.ofensiva && <OfensivaNoInicio o={painel.ofensiva} />}
      {painel.quente && <QuenteNoInicio q={painel.quente} agora={agora} />}
      {painel.missoes && <MissoesNoInicio m={painel.missoes} />}
      <button className="pontos-semana" onClick={() => ir({ tela: 'ranking' })}>
        <span><b>{painel.pontos.semana}</b> pts no ranking esta semana</span>
        <span className="ver">Ranking<Icone nome="seta" tamanho={16} /></span>
      </button>
      {prontos.length > 0 && (
        <div className="com-quem" role="radiogroup" aria-label="Jogar com">
          <button role="radio" aria-checked={com === null} className={com === null ? 'on' : undefined} onClick={() => setCom(null)}>Sozinho</button>
          {prontos.map((t) => (
            <button key={t.id} role="radio" aria-checked={com === t.id} className={com === t.id ? 'on' : undefined} onClick={() => setCom(t.id)}>
              <Escudo id={t.escudo} tamanho={18} />{t.nome}
            </button>
          ))}
        </div>
      )}
      <button className="btn1 largo" onClick={() => ir(painel.limite.restantes === 0 ? { tela: 'limite' } : { tela: 'liga', trio: com })}>JOGAR NA LIGA</button>
    </section>
  );
}

// A linha do dia: a ofensiva 🔥 (o detalhe fica no perfil) e as missões do dia, cada uma com toque para a tela dela.
function LinhaDoDia({ ofensiva, missoes }: { ofensiva?: OfensivaNaTela | null; missoes?: PainelMissoes | null }) {
  if (!ofensiva && !missoes) return null;
  const feitas = missoes?.dia.missoes.filter((x) => x.concluida).length ?? 0, total = missoes?.dia.missoes.length ?? 0;
  const bau = !!missoes && (missoes.bau.disponivel || missoes.bau.retorno.disponivel);
  return (
    <div className="linha-do-dia">
      {ofensiva && (
        <button className={'chip-dia ofensiva' + (ofensiva.hojeContou ? ' ok' : ofensiva.dias ? ' risco' : '')} onClick={() => ir({ tela: 'perfil' })}
          aria-label={`Ofensiva de ${emDias(ofensiva.dias)}${ofensiva.hojeContou ? ', hoje já contou' : ''}`}>
          <span className={'chama' + (ofensiva.dias ? '' : ' apagada')} aria-hidden="true">🔥</span><b>{ofensiva.dias}</b>{ofensiva.dias === 1 ? 'dia' : 'dias'}
        </button>
      )}
      {missoes && (
        <button className={'chip-dia missoes' + (bau ? ' pronto' : '')} onClick={() => ir({ tela: 'missoes' })}
          aria-label={`Missões do dia: ${feitas} de ${total}${bau ? ', baú pronto para abrir' : ''}`}>
          Missões <b>{feitas} de {total}</b>{bau && <i className="ponto-bau" aria-hidden="true" />}
        </button>
      )}
    </div>
  );
}

// Entrar com código: a folha com o campo do código ou do link da sala.
function FolhaDoCodigo({ aoFechar }: { aoFechar: () => void }) {
  return (
    <div className="folha-fundo" onClick={(ev) => { if (ev.target === ev.currentTarget) aoFechar(); }}>
      <div className="folha simples folha-codigo" role="dialog" aria-modal="true" aria-labelledby="folha-codigo">
        <h2 id="folha-codigo">Entrar com código</h2>
        <CampoCodigo rotulo="Código ou link da sala" aoEntrar={(c) => irParaMesa({ tela: 'sala', codigo: c })} />
        <button className="btn2" onClick={aoFechar}>Fechar</button>
      </div>
    </div>
  );
}

// Sino das notificações, com o número de não lidas.
function Sino() {
  const { naoLidas } = usePresenca();
  return (
    <button className="sino" onClick={() => ir({ tela: 'notificacoes' })}
      aria-label={naoLidas ? `Notificações, ${naoLidas} ${naoLidas === 1 ? 'nova' : 'novas'}` : 'Notificações'}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M6 8a6 6 0 0 1 12 0c0 7 3 8 3 8H3s3-1 3-8" /><path d="M10 20a2 2 0 0 0 4 0" />
      </svg>
      {naoLidas > 0 && <span className="contador" aria-hidden="true">{naoLidas > 99 ? '99+' : naoLidas}</span>}
    </button>
  );
}
